import { isDefined } from './helpers';
import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js"

export function initForm() {
    openForm();
    closeForm();
    flatPickr();
    //manageErrorCF7();
    //manageSuccessCF7();
    formPopupThanks();
    manageForm();
}

function openForm()
{
    const opens = document.querySelectorAll('.js-open-form');
    if(!isDefined(opens)) return;
    opens.forEach(function(open) {
        open.addEventListener('click', function(e) {
            e.preventDefault();
            document.body.classList.add('form-is-open');
        })
    })
}

function closeForm()
{
    const closes = document.querySelectorAll('.js-close-form');
    if(!isDefined(closes)) return;
    closes.forEach(function(close) {
        close.addEventListener('click', function(e) {
            e.preventDefault();
            document.body.classList.remove('form-is-open');
        })
    })
    //ajoute une classe sur le form wrapper
}

function flatPickr()
{
    const inputDate = document.querySelector('.js-date') || null;
    if(isDefined(inputDate))
    {
        let config = {
            dateFormat: "Y-m-d",
            locale: French,
            altInput: true,
            altFormat: "d F Y",
            minDate: "today",
        }

        const disabledDatesJson = document.querySelector('.form-content').getAttribute('data-disable-dates');
        let disabledDates = {"dates" : []};
        if(isDefined(disabledDatesJson))
        {
            disabledDates = JSON.parse(disabledDatesJson);
        }
        config.disable = disabledDates.dates;
        flatpickr(inputDate, config);
    }

    const inputTime = document.querySelector('.js-time') || null;
    if(isDefined(inputTime))
    {
        flatpickr(inputTime, {
            enableTime: true,
            disableMobile: true,
            noCalendar: true,
            dateFormat: "H\\hi",
            time_24hr: true,
            locale: French,
            minTime: "09:00",
            maxTime: "18:00",
            defaultDate: "09:00"
        });
    }
}

/*
function manageErrorCF7()
{
    function checkIfEmpty(input)
    {
        if(input.value == "" || input.value == null || input.value == undefined || input.length == 0)
        {
            return true
        }
        return false;
    }

    document.addEventListener( 'wpcf7submit', function( event ) {
        const required = event.target.querySelectorAll('[aria-required="true"]');
        required.forEach((input) => {
            if(checkIfEmpty(input))
            {
                input.classList.add('error');
            }
            else
            {
                input.classList.remove('error');
            }
        });
    }, false );
}

function manageSuccessCF7()
{
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        document.body.classList.add('form-success');
    }, false );
}
*/

function formPopupThanks()
{
    const modal = document.querySelector('.form-submit-message');
    if(isDefined(modal))
    {
        modal.addEventListener('click', function(e) {
            e.stopImmediatePropagation();
            if (!e.target.classList.contains('form-submit-message')) {
                return;
            }
            document.body.classList.remove('form-success');
        });
    }
    const button = document.querySelector('.js-modal-close');
    if(isDefined(button))
    {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            document.body.classList.remove('form-success');
        });
    }
}

function manageForm()
{
    const form = document.querySelector('#form-commande');
    if(!isDefined(form)) return;
    const remarque = document.querySelector('#remarque');

    addSelect();

    form.addEventListener('submit', function(event){
        event.preventDefault();

        if(remarque.value !== ''){
            return;
        }
        const formData = new FormData(form);
        const url = form.getAttribute('action');
        const action = document.querySelector('input[name="action"]').value;
        const formResponse = document.querySelector('.form-response');

        requestCommande(action, url,formData, function(data){
            if(data.success)
            {
                document.body.classList.add('form-success');
                formResponse.classList.add('form-success');
                if(formResponse.classList.contains('form-error'))
                {
                    formResponse.classList.remove('form-error');
                }
                formResponse.innerHTML = data.data.message;
                resetForm(form);
            }
            else
            {
                if(formResponse.classList.contains('form-success'))
                {
                    formResponse.classList.remove('form-success');
                }
                formResponse.classList.add('form-error');
                formResponse.innerHTML = data.data.message;
            }
        });
    });
}

function addSelect()
{
    const addCommande = document.querySelector('#add_commande');
    const formSelectWrapper = document.querySelector('.form-multiple-commande');
    if(!isDefined(addCommande)) return;
    addCommande.addEventListener('click', function(event){
        event.preventDefault();
        const clone = formSelectWrapper.cloneNode(true);
        clone.classList.add('form-multiple-commande-clone');
        this.before(clone);
    });
}

function removeSelect(button)
{
    const parent = button.parentElement;
    parent.remove();
}

function resetForm(form)
{
    form.reset();
    const formClone = document.querySelectorAll('.form-multiple-commande-clone');
    if(formClone.length === 0){
        return;
    }
    formClone.forEach(function(clone){
        clone.remove();
    });
}

async function requestCommande(action, url, formData, callback)
{
    await fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        credentials: 'same-origin',
        body: formData
    })
    .then(function(response){
        if(response.ok) { 
            return response.json();
        }
        throw new Error('Network response was not ok.');
    })
    .then(function(data){
        callback(data);
    })
    .catch(function(error) {
        console.log('There has been a problem with your fetch operation: ' + error.message);
    });
}